const AskQuestionTrigger = props => {
    const {
        settings,
        contentItemId,
        moduleId,
        person,
    } = props;

    const triggerButton = document.querySelector('.ask-question-trigger');
    const [showPopup, setShowPopup] = React.useState(false);

    const togglePopup = React.useCallback(() => {
        setShowPopup(visible => {
            return !visible;
        });
    }, []);

    const closePopup = React.useCallback(() => {
        setShowPopup(false);
    }, []);

    React.useEffect(() => {
        if(triggerButton){
            triggerButton.innerHTML = settings['button_text'];
            triggerButton.addEventListener('click', togglePopup);
        }
    }, []);

    return showPopup && <AskQuestion close={closePopup} person={person} settings={settings} moduleId={moduleId} contentItemId={contentItemId}/>;
};

AskQuestionTrigger.propTypes = {

};

AskQuestionTrigger.defaultProps = {

};

const AskQuestion = props => {
    
    const {
        person,
        settings,
        moduleId,
        contentItemId,
        close,
    } = props;
    
    const rootRef = React.useRef(null);
    const captcha = React.useRef(null);
    const captchaRef = React.useRef(null);
    const [top, setTop] = React.useState(0);
    const [left, setLeft] = React.useState(0);
    const [data, setData] = React.useState({
        firstname: person?.firstname || '',
        lastname: person?.lastname || '',
        email: person?.email || '',
        subject: '',
        body: '',
    });
    const [message, setMessage] = React.useState(null);
    const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
    const showPersonFields = !Boolean(person?.email);
    const showRecaptcha = Boolean(settings?.show_recaptcha === '1');
    const recaptchaSiteKey = SS?.vars?.Settings?.GoogleRecaptcha?.site_key || false;

    const onResize = React.useCallback(() => {
        setTop((window.innerHeight / 2) - (rootRef.current.clientHeight / 2));
        setLeft((window.innerWidth / 2) - (rootRef.current.clientWidth / 2));
    }, []);

    const setValue = React.useCallback(event => {
        const name = event.target.name;
        const value = event.target.value;
        const newData = {...data};
        newData[name] = value;
        setData(newData);
    }, [data]);

    const onSubmit = React.useCallback(event => {
        const payload = {
            ...data,
            'g-recaptcha-response': showRecaptcha ? grecaptcha.getResponse(captcha.current) : null,
            module_id: moduleId,
            content_item_id: contentItemId,
            _Token: {
                key: SS.csrfToken,
            },
        };

        setMessage(null);

        axios({
            method: 'post',
            url: SS.route('SystemMessages', 'SystemMessages', 'sendAskQuestion', null),
            data: payload,
        })
            .then(response => {
                onSuccess();
                setShowSuccessMessage(true);
            }).catch( error => {
                if(error.response.data.errors) {
                    setMessage(error.response.data.errors);
                }else if(error.response.data.message) {
                    setMessage({'generic': error.response.data.message});
                }else{
                    setMessage({'generic': 'Something went wrong!'});
                }
            });

    }, [data, moduleId]);

    const onClose = React.useCallback(() => {
        setData({
            firstname: person?.firstname || '',
            lastname: person?.lastname || '',
            email: person?.email || '',
            subject: '',
            body: '',
        });
        setMessage(null);
        setShowSuccessMessage(false);
        close();
    }, []);

    const onSuccess = React.useCallback(() => {
        setData({
            firstname: person?.firstname || '',
            lastname: person?.lastname || '',
            email: person?.email || '',
            subject: '',
            body: '',
        });
        setMessage(null);
    }, []);

    React.useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    React.useEffect(() => {
        if(showRecaptcha){
            SSRecaptcha.ready(function(){
                if(!captcha.current){
                    captcha.current = grecaptcha.render(captchaRef.current, {
                        'sitekey': recaptchaSiteKey,
                    });
                }
            }.bind(this));
        }
    }, [showRecaptcha]);

    return ReactDOM.createPortal(
        <React.Fragment>
            <div className={'customAlertModalFrame'} style={{display: 'block'}} onClick={onClose}/>
            <div className="customAlert" style={{display: 'block', top, left}} ref={rootRef}>
                {showSuccessMessage &&
                    <div className="customAlertInner">
                        <div className="customAlertTitle">
                            {settings.popup_title}
                            <a className="closeAlert" href="#" onClick={(event) => {
                                event.preventDefault();
                                onClose();
                            }}/>
                        </div>
                        <div className="customAlertMsg">{settings.success_message}</div>
                        <div className="customAlertButtons center">
                            <button className="customAlertButtonOk" onClick={onClose}>OK</button>
                        </div>
                    </div>
                }
                {!showSuccessMessage &&
                    <div className="customAlertInner">
                        <div className="customAlertTitle">
                            {settings.popup_title}
                            <a className="closeAlert" href="#" onClick={(event) => {
                                event.preventDefault();
                                onClose();
                            }}/>
                        </div>
                        <div className="customAlertMsg">
                            {showPersonFields &&
                                <React.Fragment>
                                    <div>First Name</div>
                                    <input required={true} type={'text'} name={'firstname'} value={data.firstname}
                                           onChange={setValue} className={message?.firstname ? 'invalid' : ''}/>
                                    <div>Last Name</div>
                                    <input required={true} type={'text'} name={'lastname'} value={data.lastname}
                                           onChange={setValue} className={message?.lastname ? 'invalid' : ''}/>
                                    <div>Email</div>
                                    <input required={true} type={'email'} name={'email'} value={data.email} onChange={setValue}
                                           className={message?.email ? 'invalid' : ''}/>
                                </React.Fragment>
                            }
                            <div>Subject</div>
                            <input required={true} type={'text'} name={'subject'} value={data.subject} onChange={setValue}
                                   className={message?.subject ? 'invalid' : ''}/>
                            <div>Message</div>
                            <textarea required={true} name={'body'} value={data.body} onChange={setValue}
                                      className={message?.body ? 'invalid' : ''}/>
                            {showRecaptcha &&
                            <div ref={captchaRef} className={'g-recaptcha'}/>
                            }
                        </div>
                        {Boolean(message) &&
                        <div className="customAlertError">
                            {Object.values(message).map((text, index) => <div key={`error-${index}`}>{text}</div>)}
                        </div>
                        }
                        <div className="customAlertButtons center">
                            <button className="customAlertButtonOk" onClick={onSubmit}>Send</button>
                            <button className="customAlertButtonOk" onClick={onClose}>Cancel</button>
                        </div>
                    </div>
                }
            </div>
        </React.Fragment>
    , document.body);
};